import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RequiredEmployeePredictionAdapter } from '../../../classes/adapters/response/prediction/RequiredEmployeeAdapter';
import { Observable } from 'rxjs';
import { DailyRequiredEmployeePrediction } from '../../../classes/models/prediction/DailyRequiredEmployeePrediction';
import { map } from 'rxjs/operators';
import { RequiredEmployeesPredictionResponse } from '../../../interfaces/response/PredictionsResponses';

/**
 * This service communicates with backend to retrieve footfall predictions.
 */
@Injectable({
  providedIn: 'root'
})
export class RequiredEmployeesPredictionService {
  private http = inject(HttpClient);
  private employeePredictionAdapter = inject(RequiredEmployeePredictionAdapter);

  url = environment.apiUrl + '/required-employees-predictions';

  /**
   * Retrieves requirement minimum number of employees predictions for the given store and date range.
   * @param storeId an identifier of a store.
   * @param from the first date of employee predictions.
   * @param to the last date of employee predictions.
   */
  getPredictions(storeId: string, from: string, to: string): Observable<DailyRequiredEmployeePrediction[]> {
    const requestParams = {
      params: { store: storeId, fromDate: from, toDate: to }
    };
    return this.http.get(this.url, requestParams).pipe(map(
      (data: RequiredEmployeesPredictionResponse[]) => data.map(item => this.employeePredictionAdapter.adapt(item)))
    );
  }
}
